module.exports = __webpack_public_path__ + "img/27.cd68d60.png";